import { TenantTrackingId, TrackingDataMap } from '../types/trackingDataModel';
import { TrackingHandlerBase } from '../types/handlers';
import { PaybackTrackingHandler } from './PaybackTrackingHandler';

export const trackingHandlerRegistry: {
  [K in TenantTrackingId]: TrackingHandlerBase<TrackingDataMap[K]>;
} = {
  payback: new PaybackTrackingHandler(),
};

export const getTrackingHandler = <T extends TenantTrackingId>(
  tenantId: T
): TrackingHandlerBase<TrackingDataMap[T]> => {
  return trackingHandlerRegistry[tenantId] ?? null;
};
